import React from 'react';
import copy from '../../copy';
import { mediaQueries, style } from '@do/walrus';
import styled from 'styled-components';
import logoFullSrc from '../../assets/logo-full.svg';
import vars from '../../assets/overwrite-vars';

const Container = styled.div`
  font-size: ${style.vars.fontSize.small};
  color: ${vars.grey4};
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: ${style.vars.whitespace.xsmall};
  max-width: 480px;
  height: 22px;
  padding-left: 10px;
  margin: 0 auto ${style.vars.whitespace.regular};
  ${mediaQueries.xsmallMax} {
    max-width: 350px;
  }
`;

function PoweredByDigitalOcean() {
  return (
    <Container>
      {copy.footer.poweredBy[0]} <img src={logoFullSrc} alt="DigitalOcean Logo" width="100px" height="16px" />
    </Container>
  );
}

export default PoweredByDigitalOcean;
